import React from 'react';
import styled from 'styled-components';
import { HudIcon } from '../Icons/HudIcons';
import { themeColor } from '../theme/colors';
import { smBold } from '../theme/typography';

interface MCPBannerSidebarItemProps {
  className?: string;
}

const Container = styled.a`
  ${smBold};
  position: relative;
  display: flex;
  width: calc(100% - 2px);
  padding: 10px 12px;
  justify-content: space-between;
  align-items: center;
  transition: background 0.2s ease-out;

  margin-top: 20px;

  border-radius: 8px;
  color: ${themeColor('textTertiary')};
  background: ${themeColor('backgroundLight')};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0);
    color: black;
  }

  &:before {
    pointer-events: none;
    border-radius: 8px;
    content: '';
    background-image: linear-gradient(to bottom right, #fae9fc 0%, #8e72f5 100%);
    padding: 10px;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
    top: -1px;
    left: -1px;
    position: absolute;
    z-index: -1;
  }
`;

export function MCPBannerSidebarItem({ className }: MCPBannerSidebarItemProps) {
  return (
    <Container
      className={className}
      href="https://docs.hud.io/docs/hud-mcp-server"
      target="_blank"
    >
      HUD MCP Server
      <HudIcon icon="trends.arrowUp" />
    </Container>
  );
}

export default MCPBannerSidebarItem;
